module.exports = __webpack_public_path__ + "static/pwc-3c01e3104e189c73645dbe71a4da7fca.png";